import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';

export type ChatInputTokenSlots = {
  root: Slot<'span'>;
};

/**
 * ChatInputToken Props
 */
export type ChatInputTokenProps = ComponentProps<ChatInputTokenSlots> & {};

/**
 * State used in rendering ChatInputToken
 */
export type ChatInputTokenState = ComponentState<ChatInputTokenSlots>;
